export function smoothScrollTo(elementId: string, duration: number = 800) {
	const element = document.getElementById(elementId);
	if (!element) return;

	const navHeight = 80;
	const startPosition = window.scrollY;
	const elementPosition = element.getBoundingClientRect().top + startPosition;
	const targetPosition = elementPosition - navHeight;
	const distance = targetPosition - startPosition;
	const startTime = performance.now();

	function animateScroll(currentTime: number) {
		const elapsed = currentTime - startTime;
		const progress = Math.min(elapsed / duration, 1);

		const easeInOutCubic = (t: number): number => {
			return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
		};

		const easedProgress = easeInOutCubic(progress);
		const currentPosition = startPosition + distance * easedProgress;

		window.scrollTo(0, currentPosition);

		if (progress < 1) {
			requestAnimationFrame(animateScroll);
		}
	}

	requestAnimationFrame(animateScroll);
}
